export enum CoreCatalogOptionTags {
  CatalogOptionsDictionary = 'CatalogOptionsDictionary',
}

export const coreCatalogOptionTagTypes = Array.from(Object.values(CoreCatalogOptionTags));
